import { axiosCompanyPortalInstance } from "./";

/** Company Portal Evaluations (PROLINE-2969) + Satisfaction Survey view (PROLINE-2998).
 * Pagination is returned via response headers (Current-Page, Page-Items,
 * Total-Count, Total-Pages). Base URL is the company portal instance. */

const EVALUATIONS_PATH = "/evaluations";
const EVALUATION_FORMS_PATH = "/evaluation_forms";

// Evaluation rounds
const getCompanyEvaluations = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get(EVALUATIONS_PATH, { ...config, params });

const getCompanyEvaluation = (id) =>
  axiosCompanyPortalInstance.get(`${EVALUATIONS_PATH}/${id}`);

const createCompanyEvaluation = (eventId) =>
  axiosCompanyPortalInstance.post(EVALUATIONS_PATH, { event_id: eventId });

const updateCompanyEvaluation = ({ id, evaluation }) =>
  axiosCompanyPortalInstance.patch(`${EVALUATIONS_PATH}/${id}`, { evaluation });

// Evaluation forms
const getCompanyEvaluationForms = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get(EVALUATION_FORMS_PATH, { ...config, params });

const getCompanyEvaluationForm = (id) =>
  axiosCompanyPortalInstance.get(`${EVALUATION_FORMS_PATH}/${id}`);

const submitCompanyEvaluationForm = ({ id, data }) =>
  axiosCompanyPortalInstance.patch(`${EVALUATION_FORMS_PATH}/${id}`, data);

// Satisfaction survey (read-only view for the company)
const getCompanyEventSatisfactionSurvey = (eventId) =>
  axiosCompanyPortalInstance.get(`/events/${eventId}/satisfaction_survey`);

export {
  getCompanyEvaluations,
  getCompanyEvaluation,
  createCompanyEvaluation,
  updateCompanyEvaluation,
  getCompanyEvaluationForms,
  getCompanyEvaluationForm,
  submitCompanyEvaluationForm,
  getCompanyEventSatisfactionSurvey,
};
